
import axios from "axios";
import { getCountry } from './common-utils';

const getSelectedProductIds = (closestStores, selectedSizes, selectedAccessories) => {
    let selectedProductIds = [];
    if (selectedSizes && selectedSizes.length > 0) {
        selectedProductIds = selectedProductIds.concat(selectedSizes.map((i) => i.product_sku));
    }
    if (selectedAccessories && selectedAccessories.length > 0) {
        selectedProductIds = selectedProductIds.concat(selectedAccessories.map((i) => i.product_sku));
    }
    return selectedProductIds;
}

export async function getStores(postCodeOrSuburb){
    return new Promise(async (resolve, reject) => {
        
        const country = getCountry();
        /* global jQuery */
        const geocodeUrl = (jQuery.isNumeric(postCodeOrSuburb)) 
            ? `https://nominatim.openstreetmap.org/search?postalcode=${postCodeOrSuburb}&country=${country}&format=json`
            : `https://nominatim.openstreetmap.org/search?city=${postCodeOrSuburb}&country=${country}&format=json`;

        const results = await axios({
            method: 'get',
            url: geocodeUrl 
        });
        
        let storesRequestUrl = '';
        if (results.data.length > 0) {
            const geocode = results.data[0];
            storesRequestUrl = `/stockists/index/search?latitude=${geocode.lat}&longitude=${geocode.lon}&country=AU&radius=100&units=km`;
        }
        else {
            const msg = `No stores near ${(jQuery.isNumeric(postCodeOrSuburb))? 'postcode': 'suburb' } ${postCodeOrSuburb}.`;
            console.log(msg);
            reject(msg);
            return;
        }
        
        axios({
            method: "get",
            url: storesRequestUrl,
        })
        .then((response) => {
            if (response.data.error) { // If there is an error
                console.error(response.data.message);
                resolve([]);
            } 
            else {
                // Closest 5 stores
                let data = response.data.results.results ? response.data.results.results : [];
                let closestStores = [];
        
                if (response.data.results.results){
                    for (let i = 0; i < data.length; i++) {
                      if (closestStores.length === 5) { break; }
                      if(data[i].rms_store_code !== ""){
                        closestStores.push(data[i]);    
                      }
                    }
                } 
                resolve(closestStores);
            }
        })
        .catch((error) => {
            reject(error);
        });
    });
}

export async function getStoreStock(closestStores, products, defaultProductOutOfStockBuffer, defaultProductLowStockBuffer, stockCheckApiEndpoint, stockCheckApiKey){

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: window.location.origin + '/rest/V1/rms/get-stock-in-store-availability',
            data: {
                data: {
                    storeCodes: closestStores.map((i) => i.rms_store_code),
                    itemColourSizes: products
                }
            }
        })
        .then(async(response) => {
            const stockByStores = {};
            if (!response.data.stock_in_store) {
                return stockByStores;
            }

            let stockInStore = response.data.stock_in_store;

            // Get the stock buffers for the selected products.
            const productStockBuffers = await getStoreStockBuffersForProducts(products);

            stockInStore.forEach((i) => {
                const storeCode = i.store.store_code;

                if (!stockByStores[storeCode]) {
                    stockByStores[storeCode] = {
                        storeCode: storeCode, inStock: [], lowStock: [], noStock: []
                    };
                }

                // Use the stock buffer defined at the product level to determine if the store product is low in stock or out of stock.
                const productStockBuffer = productStockBuffers[i.sku.item_colour_ref];
                let productOutOfStockBuffer, productLowStockBuffer;

                if (productStockBuffer) {
                    productOutOfStockBuffer = productStockBuffer.store_oos_buffer;
                    productLowStockBuffer = productStockBuffer.store_low_buffer;
                }
                else {
                    productLowStockBuffer = defaultProductLowStockBuffer;
                    productOutOfStockBuffer = defaultProductOutOfStockBuffer;
                }

                // Add to the correct stock category based on the quantity of the product sku.
                if (i.quantity_available <= productOutOfStockBuffer ) { // Out of stock
                    stockByStores[storeCode].noStock.push(i.sku.item_colour_ref);
                }
                else if (i.quantity_available <= productLowStockBuffer) { // Low stock
                    stockByStores[storeCode].lowStock.push(i.sku.item_colour_ref);
                }
                else if (i.quantity_available > productLowStockBuffer) { // Have stock
                    stockByStores[storeCode].inStock.push(i.sku.item_colour_ref);
                }
            });
            resolve(stockByStores);
        })
        .catch((e) => {
            if(e?.isAxiosError) {
                const msg = `No stores near selected area.`;
                reject(msg);
                return;
            }
            reject(e);
        });
    });  
}

export function getStoreStockBuffersForProducts(products){
    return new Promise(async(resolve) => {
        const storeStockBufferPromises = products.map((product) => {
            return new Promise( async (resolve) => {
                const stockBuffers = await getProductStoreStockBuffers(product);
                const response = {};
                response[product] = stockBuffers;
                resolve(response);
            });
        });

        let productStockBuffers = {};
        const results = await Promise.all(storeStockBufferPromises);
        // Convert array to map.
        results.forEach((i) => productStockBuffers[Object.keys(i)[0]] = Object.values(i)[0]);
        resolve(productStockBuffers);
    });
}

export async function getProductStoreStockBuffers(sku){
    return new Promise((resolve) => {
        const defaultStock = {
            store_low_buffer: 3,
            store_oos_buffer: 1
        };

        axios({
            method: 'post',
            url: `/graphql`,
            data: {
                query: `{
                    stock_buffers(sku: "${sku}"){ 
                        store_low_buffer 
                        store_oos_buffer
                    }
                }`
            },
            headers: {'Content-Type': 'application/json'},
        })
        .then((response) => {
            const data = response.data;
            if (data.errors){
                resolve(defaultStock);
            } 
            else {
                resolve(data.data.stock_buffers);
            } 
        })
        .catch((e) => {
            console.error(e);
            resolve(defaultStock);
        });
    });
}
